import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { queryClient } from "@/lib/queryClient";
import { getGoogleClientId } from "@/lib/env";
import App from "@/App";
import "@/globals.css";

const googleClientId = getGoogleClientId();

// Sem client_id, NAO montar o GoogleOAuthProvider — caso contrario o SDK do
// Google dispara um GET pra accounts.google.com/gsi/button?client_id= e
// retorna 400 a cada page load (CAAS-4301).
const tree = (
  <QueryClientProvider client={queryClient}>
    {googleClientId ? (
      <GoogleOAuthProvider clientId={googleClientId}>
        <App />
      </GoogleOAuthProvider>
    ) : (
      <App />
    )}
  </QueryClientProvider>
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>{tree}</React.StrictMode>,
);
